import Vue from 'vue'
import Router from 'vue-router'
import { API_APPS, ROUTER_MODE } from '@/api/config'
import LoginView from '@/views/public/LoginView'
import ResetPasswordView from '@/views/public/ResetPasswordView'
import ResetPasswordSSNView from '@/views/public/ResetPasswordSSNView'
import WelcomeView from '@/views/public/WelcomeView'
import ThankYouView from '@/views/public/ThankYouView'
import ApplicationView from '@/views/public/ApplicationView'
import ApplicationListView from '@/views/public/ApplicationListView'
import AuthUser from '@/classes/auth/AuthUser'
import ResetPasswordConfirmationForm
  from '@/components/confirmation/ResetPasswordConfirmationForm'
import ConfirmationForm from '@/components/confirmation/ConfirmationForm'
import CertificatesListView from '@/views/public/CertificatesListView'
import CertificateDetailView from '@/views/public/CertificateDetailView'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'WelcomeView',
    component: WelcomeView,
    meta: { requiresAuth: false }
  },
  {
    path: '/login',
    name: 'LoginView',
    component: LoginView,
    meta: { requiresAuth: false }
  },
  {
    path: '/password-resets/:code',
    name: 'ResetPasswordConfirmationForm',
    component: ResetPasswordConfirmationForm,
    props: true,
    meta: { requiresAuth: false }
  },
  {
    path: '/reset-password',
    name: 'ResetPasswordView',
    component: ResetPasswordView,
    meta: { requiresAuth: false }
  },
  {
    path: '/reset-password-ssn',
    name: 'ResetPasswordSSNView',
    component: ResetPasswordSSNView,
    meta: { requiresAuth: false }
  },
  {
    path: '/account/confirm/:code',
    name: 'ConfirmationForm',
    component: ConfirmationForm,
    props: true,
    meta: { requiresAuth: false }
  },
  {
    path: '/application/thank-you',
    name: 'ThankYouView',
    component: ThankYouView,
    props: true,
    meta: { requiresAuth: false }
  },
  {
    path: '/applications',
    name: 'ApplicationListView',
    component: ApplicationListView,
    meta: { requiresAuth: false }
  },
  {
    path: '/application/:code',
    name: 'ApplicationView',
    component: ApplicationView,
    props: true,
    meta: { requiresAuth: false }
  },
  {
    path: '/dashboard',
    name: 'DashboardView',
    beforeEnter: goToDashboard
  },
  {
    path: '/certificates',
    name: 'CertificatesListView',
    component: CertificatesListView,
    meta: { requiresAuth: false }
  },
  {
    path: '/certificates/:certificateId',
    name: 'CertificateDetailView',
    component: CertificateDetailView,
    props: true,
    meta: { requiresAuth: false }
  },
  {
    path: '*',
    redirect: '/'
  }
]

function goToDashboard () {
  if (AuthUser.isLoggedIn()) {
    if (AuthUser.isAdministrator()) {
      window.location.replace(API_APPS.ADMINISTRATOR + '/')
    } else if (AuthUser.isAuditor()) {
      window.location.replace(API_APPS.AUDITOR + '/')
    } else if (AuthUser.isCustomer()) {
      window.location.replace(API_APPS.CUSTOMER + '/')
    } else if (AuthUser.isManager()) {
      window.location.replace(API_APPS.MANAGER + '/')
    } else if (AuthUser.isHR()) {
      window.location.replace(API_APPS.HR + '/')
    }
  }
}

const router = new Router({
  mode: ROUTER_MODE,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
  linkActiveClass: 'is-active'
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!AuthUser.isLoggedIn()) {
      next('/login')
    } else {
      next()
    }
  } else if (to.matched.some(record => !record.meta.requiresAuth)) {
    next()
  }
})

export default router
